var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog"},[_vm._v(" HOLD KEY ON EARPIECE UNTIL AFTER PIN ENTRY ")])}
var staticRenderFns = []

export { render, staticRenderFns }